import { useRef, useState } from "react"
import classNames from "classnames"

import { ReactComponent as IconDown } from "assets/svg/icon-down.svg"

import { useOutsideClick } from "utils/useOutsideClick"
import { ButtonNew } from "components/form/ButtonNew"

import styles from "./index.module.scss"

interface AddContractorButtonProps {
  onAddContractor: () => void
  onAddEnterprise: () => void
}

export const AddContractorButton = ({ onAddContractor, onAddEnterprise }: AddContractorButtonProps) => {
  const [showDropdown, setShowDropdown] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  const closeDropdown = () => setShowDropdown(false)

  useOutsideClick(dropdownRef, closeDropdown, false, { preserveClick: true })

  const onAddClick = () => {
    setShowDropdown(prevState => !prevState)
  }

  const handleSingleClick = () => {
    closeDropdown()
    onAddContractor()
  }

  const handleEnterpriseClick = () => {
    closeDropdown()
    onAddEnterprise()
  }

  return (
    <div className={styles.wrapper} ref={dropdownRef}>
      <ButtonNew
        onClick={onAddClick}
        color="blue"
        className={classNames(styles.addContractorButton, {
          [styles.addContractorButtonOpen]: showDropdown,
        })}
      >
        Add contractor
        <IconDown />
      </ButtonNew>
      <div
        className={classNames(styles.dropdown, {
          [styles.dropdownOpen]: showDropdown,
        })}
      >
        <button className={styles.dropdownItem} onClick={handleSingleClick}>
          Single
        </button>
        <button className={styles.dropdownItem} onClick={handleEnterpriseClick}>
          Enterprise
        </button>
      </div>
    </div>
  )
}
